var map = {
	"./163236.jpeg": 6932,
	"./Snowflake-icon.png": 3453,
	"./cabinIcon-green.png": 1694,
	"./cabinIcon.png": 2710,
	"./demo.jpg": 2736,
	"./demoBilde.jfif": 5304,
	"./demoKart.png": 3895,
	"./svsf.jpg": 2048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;